<template>
  <div id="dialog-interest">
    <!-- Dialog Item -->
    <v-dialog v-model="dialogInterest" max-width="800px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap align-center justify-center text-xs-center class="px-5">
              <v-flex xs12 class="my-2">
                <div class="display-1">เลือกสิ่งที่คุณสนใจ</div>
              </v-flex>
              <v-flex xs10>
                <v-chip 
                  label 
                  small 
                  v-for="item, index in interests" 
                  :key="item.typeid" 
                  @click="onClickChip(item)"
                  :color="colorChipSelected(item.selected)" 
                  :selected="item.selected"
                  text-color="white"
                  >
                  {{item.nametha}}
                  <v-icon small right>{{iconChipSelected(item.selected)}}</v-icon>
                </v-chip>
                <!-- <v-checkbox
                  class="checkbox-interest"
                  :label="item.nametha"
                  :value="item.typeid"
                  v-model="selectedInterests"
                  color="red"
                  hide-details
                ></v-checkbox> -->
              </v-flex>
              <!-- <v-flex xs12>
                <table>
                    <tr>
                      <td> {{ item.nametha }} </td>
                    </tr>
                </table>
              </v-flex> -->
              <v-flex xs12 class="my-2">
                <v-btn v-if="buttonSubmit" dark class="btn-submit-interest subheading" @click="submitInterest" :loading="loadingSubmit">เสร็จสิ้น</v-btn>
                <v-btn flat v-else class="subheading">คุณสามารถเลือกได้มากกว่า 1 ชนิด</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> 
  </div>
</template>

<script>
export default {
  name: 'dialog-interest',
  data() {
    return {
      // Dialog
      dialogInterest: true,
      // item
      interests: [],
      // selectedInterests: []
      buttonSubmit: false,
      loadingSubmit: false
    }
  },
  props: {
    userInterest: {
      type: Array,
      required: true,
      validate: function(value) {
        return ['syncing', 'synced', 'version-conflict', 'error'].indexOf(value) !== -1
      }
    }
  },
  watch: {
    interests: function() {
      this.userInterest.forEach(element => {
        this.interests.forEach(item => {
          if (element.typeid == item.typeid) {
            item.selected = true
            this.buttonSubmit = true
          }
        })
      })
    }
  },
  created() {
    this.getTypesByOrders()
    this.watchUserInterest()
  },
  methods: {
    async submitInterest() {
      try {
        this.loadingSubmit = !this.loadingSubmit
        const data = {
          userid: this.$session.get('userid'),
          typeids: []
        }

        this.interests.forEach(element => {
          if (element.selected === true) {
            data.typeids.push(element.typeid)
          }
        })

        // API insert user's interested
        axios.post('https://api.farmerspace.co/marketplace/insertInterest', data).then(response => {
          if (response.status === 200) {
            // update count login to 1 after choose interest
            this.updateCountLogin()
            this.dialogInterest = !this.dialogInterest
            this.loadingSubmit = !this.loadingSubmit
            iziToast.info({
              title: 'Congrats!',
              message: 'Your interest is update',
              position: 'bottomRight'
            })
          }
        })
      } catch (error) {
        this.loadingSubmit = !this.loadingSubmit
        console.log(error)
      }
    },
    iconChipSelected(selected) {
      if (selected === true) {
        return 'done'
      } else {
        return 'add'
      }
    },
    colorChipSelected(selected) {
      if (selected === true) {
        return 'green accent-4'
      } else {
        return 'grey darken-3'
      }
    },
    onClickChip(item) {
      item.selected = !item.selected
      let findSelectedChip = this.interests.find(item => item.selected === true)
      if (!findSelectedChip) {
        // if dont choose any chip
        this.buttonSubmit = false
      } else {
        this.buttonSubmit = true
      }
      // if (this.selectedInterests.length > 0) {
      //   let findItem = this.selectedInterests.find(item => item === typeid)
      //   if (typeid === findItem) {
      //     let index = this.selectedInterests.indexOf(typeid)
      //     // this.selectedInterests.splice(index, 1)
      //     this.$delete(this.selectedInterests, index)
      //   } else {
      //     this.selectedInterests.push(typeid)
      //   }
      // } else {
      //   this.selectedInterests.push(typeid)
      // }
    },
    async getTypesByOrders() {
      try {
        this.interests = []
        const response = await axios.get(
          'https://api.farmerspace.co/marketplace/getTypesByOrders/exclude/0'
        )
        if (response.status === 200) {
          response.data.forEach(element => {
            this.interests.push({
              typeid: element.typeid,
              nametha: element.nametha,
              nameeng: element.nameeng,
              selected: false
            })
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updateCountLogin() {
      axios
        .put('https://api.farmerspace.co/marketplace/updateCountLogin', {
          userid: this.$session.get('userid')
        })
        .then(response => {
          if (response.data.message === true) {
            // console.log('login count updateed')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-interest .input-group label {
  font-size: 12px !important;
}
.btn-submit-interest {
  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%);
}
</style>


// WEBPACK FOOTER //
// src/components/dialogs/Interest.vue